import { render, staticRenderFns } from "./ComponentLockingPosition.vue?vue&type=template&id=be8c6966"
import script from "./ComponentLockingPosition.vue?vue&type=script&lang=js"
export * from "./ComponentLockingPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports